import {NotImplementedError, ValueError} from "./exceptions";

class baseForm {
    constructor(data) {
        if (typeof data !== "object") {
            throw new ValueError("Invalid parameter type")
        }
    }

    isValid() {
        throw new NotImplementedError("Method not implemented")
    }

    get errors() {
        throw new NotImplementedError("Getter not implemented")
    }
}

export default class Form extends baseForm {
    constructor(data) {
        super(data);
        this._data = data;
        this._isValidCalled = false;
        this._errors = {};
    }

    isValid() {
        if (this._isValidCalled) {
            return Object.keys(this._errors).length === 0
        }
        this._isValidCalled = true;
        Object.keys(this).forEach(k => {
            if (!k.startsWith("_")) {
                const val = this._data[k] !== undefined ? this._data[k] : this[k].zeroValues[0];
                    this[k].clean(val);
                if (this[k].hasErrors) {
                    this._errors[k] = this[k].errors
                }
            }
        });

        return Object.keys(this._errors).length === 0
    }

    get errors() {
        this.isValid();
        return this._errors
    }
}